import React from "react";

const WebsiteDevelopment = () => {
  return (
    <div className="mt-16 max-w-5xl mx-auto px-6 lg:px-8">
      <div className="bg-card border border-border/50 rounded-xl p-6 brand-shadow">
        <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
          <span className="w-1.5 h-6 bg-primary rounded-full"></span>
          Website Development
        </h2>

        <div className="mt-6 space-y-4">
          <div className="flex justify-between items-center border-b border-border/30 pb-3">
            <span className="font-semibold text-foreground">
              E-Commerce Website Development
            </span>
            <span className="font-bold text-foreground">₹40,000</span>
          </div>

          <div className="flex justify-between items-center border-b border-border/30 pb-3">
            <span className="font-semibold text-foreground">
              Shopify Based E-Commerce (Upto 60 Products)
            </span>
            <span className="font-bold text-foreground">₹10,000</span>
          </div>

          <div className="flex justify-between items-center border-b border-border/30 pb-3">
            <span className="font-semibold text-foreground">
              Shopify Based E-Commerce (Upto 150 Products)
            </span>
            <span className="font-bold text-foreground">₹20,000</span>
          </div>

          <div className="flex justify-between items-center border-b border-border/30 pb-3">
            <span className="font-semibold text-foreground">
              E-Commerce Shopify Based App
            </span>
            <span className="font-bold text-foreground">₹40,000</span>
          </div>

          <div className="flex justify-between items-center border-b border-border/30 pb-3">
            <span className="font-semibold text-foreground">
              Static Website
            </span>
            <span className="font-bold text-foreground">₹8,000</span>
          </div>

          <div className="flex justify-between items-center border-b border-border/30 pb-3">
            <span className="font-semibold text-foreground">
              Dynamic Website
            </span>
            <span className="font-bold text-foreground">₹15,000+*</span>
          </div>
        </div>

        <p className="mt-4 text-sm text-muted-foreground">
          * Dynamic website pricing starts at ₹15,000 and depends on your
          requirement — number of pages, database, admin panel, and
          integrations involved. Final pricing covers only the features and
          scope discussed and finalized at the time of agreement; any
          additional features or enhancements requested later will be
          charged separately.
        </p>
      </div>
    </div>
  );
};

export default WebsiteDevelopment;